import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import '../../../App.css';


import DoctorInfoBlock from '../Blocks/DoctorInfoBlock';

export default function AddDoctorModal(props) {
  const [scroll, setScroll] = React.useState('body');



  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (

    <div>

      <Dialog
        open={props.open}
        onClose={props.handleClose}
        scroll={scroll}
        sx={{

        }}
        BackdropProps={{
          style: {
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(3px)'
          }
        }}
        PaperProps={{
          style: {
            // backgroundColor: 'transparent',
            borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              borderBottomLeftRadius: 15,
              borderBottomRightRadius: 15,
              // borderStyle: 'solid',
              // borderWidth: '0px 2px 2px 0px',
              // borderColor: '#59776F',
            boxShadow: '#00000055 0px 6px 12px',
          },
        }}
        style={{
          
        }}
        maxWidth={'md'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >

        <DialogContent dividers={false} sx={{
          padding: 0,
          overflowX: 'hidden',
          backgroundColor: 'transparent'

        }}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <div style={{
              width: '100%',
              backgroundColor: '#F8F8F8',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              borderBottomLeftRadius: 15,
              borderBottomRightRadius: 15,
              borderStyle: 'solid',
              borderWidth: '0px 2px 2px 2px',
              borderColor: '#59776F',

            }}>
              <div style={{

                border: '5px solid #59776F',
                // borderRadius:20,
                borderTopLeftRadius: 15,
                borderTopRightRadius: 15,
                background: '#59776F',
                height: '24px',
                marginTop: 0,
                width: '100.1%'
              }}>

              </div>
              <div style={{ display: 'flex',marginTop:20, flexDirection: 'row', width: '100%', marginBottom: 20 }}>
                <div style={{ flex: 1, }}>
                </div>
                <div style={{ flex: 1, justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'space-between' }}>
                    <h3 style={{  flex: 1, textAlign: 'center', color: '#52676F' }}>معلومات الطبيب</h3>
                    <div style={{
                      border: '2px solid #2E5266',
                      borderRadius: '12px',
                      background: '#2E5266',
                      height: '1px',

                    }}>
                    </div>
                  </div>
                </div>
                <div style={{ flex: 1, justifyContent: 'end', display: 'flex', alignItems: 'center' }}>
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'end',
                    paddingLeft: 20
                  }}>
                    <IconButton onClick={()=>{props.handleClose()}} aria-label="اغلاق">
                      <CloseIcon style={{ fontSize: 60, color: '#52676F' }} />
                    </IconButton>
                  </div>
                </div>
              </div>
              <div style={{display:'flex',flexDirection:'column',width:'100%',marginBottom:20}}>
                <div style={{display:'flex',flex:1,paddingTop:20,paddingBottom:20}}>
                    <DoctorInfoBlock/>
                </div>
              </div>
            </div>

          </DialogContentText>
        </DialogContent>

      </Dialog>
    </div>

  );
}
